import { Button, Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './KeywordFilter.module.scss';

const cx = classNames.bind(styles);

interface KeywordFilterProps {
  value: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  placeholder?: string;
  maxLength?: number;
  searchDataTestId?: string;
  inputDataTestId?: string;
  clearDataTestId?: string;
  autoComplete?: string;
  fluid?: boolean;
}

const KeywordFilter = ({
  value,
  onKeyDown,
  onChange,
  placeholder,
  maxLength,
  onClear,
  searchDataTestId,
  inputDataTestId,
  clearDataTestId,
  autoComplete,
  fluid,
}: KeywordFilterProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <div className={cx('search-icon')} data-testid={searchDataTestId}>
        <Icon name={ICONS.Search} height={12} width={12} />
      </div>
      <input
        className={cx('input', { fluid })}
        value={value}
        autoComplete={autoComplete}
        aria-label={placeholder}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
        onChange={onChange}
        placeholder={placeholder}
        data-testid={inputDataTestId}
      />
      {value.length > 0 && onClear && (
        <Button ariaLabel="clear input" className={cx('clear-button')} dataTestId={clearDataTestId} onClick={onClear}>
          <Icon name={ICONS.Clear} width={12} height={12} />
        </Button>
      )}
    </div>
  );
};

export default KeywordFilter;
